import type React from 'react';

import { SearchIcon } from '@vlabs/icons';
import { permissions } from '@vlabs/shared/config';
import { routes } from '@vlabs/shared/navigation/routes';
import type { WithDataTestid } from '@vlabs/uikit/types';
import qs from 'qs';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { ButtonWithPermissions } from '../../shared/ui/button-with-permissions';

interface SearchSimilarFacesButtonProps extends WithDataTestid {
  faceId: string;
  variant?: 'filled' | 'flat' | 'outlined' | 'dimmed' | 'flat-inverted';
  size?: 'medium' | 'small';
}

export function SearchSimilarFacesButton({
  faceId,
  variant = 'flat',
  size = 'small',
  'data-testid': dataTestId = 'searchSimilarFacesButton',
}: SearchSimilarFacesButtonProps): React.JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();

  const buttonTitle = t('monokit:search similar faces.button');
  const searchPath = `${routes.search}?${qs.stringify({
    references: [{
      id: faceId,
      type: 'face',
      referenceType: 'face',
      candidateOrigin: 'faces',
    }],
  })}`;

  return (
    <ButtonWithPermissions
      data-testid={dataTestId}
      icon={<SearchIcon />}
      onClick={() => history.push(searchPath)}
      permissions={{ rules: [permissions.face.matching], method: 'allof' }}
      size={size}
      title={buttonTitle}
      variant={variant}
    >
      {buttonTitle}
    </ButtonWithPermissions>
  );
}
